import React, { useMemo } from 'react'
import styles from './ProDisplay.module.scss'
import { StarIcon as StarIconOutline } from '@heroicons/react/24/outline'
import { StarIcon as StarIconSolid } from '@heroicons/react/24/solid'
import { useState, useEffect } from 'react'
import axios from 'axios'
import {
	ChevronRightIcon,
	CheckCircleIcon,
	QuestionMarkCircleIcon,
} from '@heroicons/react/24/solid'
import { useNavigate } from 'react-router-dom'
import { useStateMachine } from 'little-state-machine'
import { updateStore } from '../../store'
import { ModalProProfile } from '../modal/ModalProProfile'

const CAREER_LEVEL_LABELS = {
	NEWBIE: '신입(1년 미만)',
	ONE_TO_THREE: '1~3년차',
	FOUR_TO_SIX: '4~6년차',
	SEVEN_TO_TEN: '7~10년차',
	OVER_TEN: '10년 이상',
}

const ProDisplay = ({
	pro,
	alreadyOffer = false,
	actionDisabled = false,
	colorMode = 'default',
	attendanceLabel = null, // '출전 예정' | '출전 여부 미확정' (대회 선택 시에만 표시)
}) => {
	const { actions, state } = useStateMachine({ updateStore })
	const API_URL = process.env.REACT_APP_API_ENDPOINT
	const [isProfileModalOpen, setIsProfileModalOpen] = useState(false)
	const [isFavorite, setIsFavorite] = useState(false)
	const [tourType, setTourType] = useState('')
	const [firstText, setFirstText] = useState('')
	const [secondText, setSecondText] = useState('')
	const [displayIcon, setDisplayIcon] = useState(null)
	const navigate = useNavigate()
	useEffect(() => {
		console.log(pro)
		const defineFirstText = () => {
			let tourTypeText = ''
			let firstText = ''
			if (pro?.user_tour_pro?.tour_type) {
				tourTypeText = pro?.user_tour_pro?.tour_type
			}
			if (pro?.name) {
				firstText = pro?.name + ' 프로'
			}
			setTourType(tourTypeText)
			setFirstText(firstText)
		}
		defineFirstText()
	}, [pro])

	useEffect(() => {
		const defineSecondText = () => {
			const parts = []
			const sponsorName =
				pro?.user_tour_pro?.main_sponsor?.name || pro?.user_tour_pro?.main_sponsor
			if (sponsorName) parts.push(sponsorName)
			const agencyName = pro?.user_tour_pro?.agency?.name || pro?.user_tour_pro?.agency_name
			if (agencyName) parts.push(agencyName)
			const level = pro?.user_tour_pro?.career_level
			if (level) parts.push(CAREER_LEVEL_LABELS[level] || level)
			setSecondText(parts.join(' · '))
		}
		defineSecondText()
	}, [pro])

	const [jobPostCount, setJobPostCount] = useState(0)

	// const fetchJobPostCount = async () => {
	// 	try {
	// 		const response = await axios.get(`${API_URL}/job-post/user/${pro?.id}`)
	// 		console.log(response.data)
	// 		console.log('공고 횟수', response.data.length)
	// 		setJobPostCount(response.data.length)
	// 	} catch (error) {
	// 		console.log(error)
	// 		setJobPostCount(0)
	// 	}
	// }

	// useEffect(() => {
	// 	if (pro?.id) {
	// 		fetchJobPostCount()
	// 	}
	// }, [pro?.id])

	const renderDisplayIcon = () => {
		return (
			<>
				{pro?.user_tour_pro?.top10_count != null && pro.user_tour_pro.top10_count > 0 && (
					<div className={styles.displayIcon}>
						TOP10 {pro.user_tour_pro.top10_count}회
					</div>
				)}
				{pro?.user_tour_pro?.cut_through_rate != null &&
					pro.user_tour_pro.cut_through_rate > 0 && (
						<div className={styles.displayIcon}>
							컷통과 {pro.user_tour_pro.cut_through_rate}%
						</div>
					)}
				{jobPostCount > 0 && (
					<div className={`${styles.displayIcon} ${styles.jobPostCount}`}>
						진행중인 공고 {jobPostCount}건
						<ChevronRightIcon className={styles.chevronIcon} />
					</div>
				)}
			</>
		)
	}

	// secondLayer에 표시할 내용이 있는지 직접 확인
	const hasTop10 = pro?.user_tour_pro?.top10_count != null && pro.user_tour_pro.top10_count > 0
	const hasCutThrough =
		pro?.user_tour_pro?.cut_through_rate != null && pro.user_tour_pro.cut_through_rate > 0
	const hasJobPost = jobPostCount > 0
	const hasSecondLayerContent = hasTop10 || hasCutThrough || hasJobPost
	const hasOfferButton = !alreadyOffer && !actionDisabled
	const shouldShowSecondLayer = hasSecondLayerContent || hasOfferButton

	useEffect(() => {
		setDisplayIcon(renderDisplayIcon())
	}, [pro, jobPostCount])

	const handleProfileClick = (e) => {
		e.stopPropagation()
		setIsProfileModalOpen(true)
	}

	return (
		<>
			<div
				className={`${styles.proDisplayContainer} ${colorMode === 'green' ? styles.greenMode : ''}`}>
				{attendanceLabel && (
					<div
						className={
							attendanceLabel === '출전 예정'
								? styles.attendanceLabelExpected
								: styles.attendanceLabelUnconfirmed
						}>
						{attendanceLabel === '출전 예정' ? (
							<CheckCircleIcon className={styles.attendanceLabelIcon} />
						) : (
							<QuestionMarkCircleIcon className={styles.attendanceLabelIcon} />
						)}
						<span>{attendanceLabel}</span>
					</div>
				)}
				<div
					className={styles.firstLayer}
					onClick={handleProfileClick}
					role="button"
					tabIndex={0}
					onKeyDown={(e) => e.key === 'Enter' && handleProfileClick(e)}
					aria-label="프로필 상세 보기">
					<div className={styles.firstLayerLeft}>
						<div className={styles.profileImageArea}>
							<img
								src={pro?.profile_image || '/images/pro-default.png'}
								alt="pro profile"
								onError={(e) => {
									e.target.src = '/images/pro-default.png'
								}}
							/>
						</div>
						<div className={styles.firstLayerTextArea}>
							<div className={styles.firstLayerFirstText}>
								{tourType && (
									<span className={styles.tourTypeLabel}>{tourType}</span>
								)}
								<span>{firstText}</span>
							</div>
							{secondText ? (
								<div className={styles.firstLayerSecondText}>{secondText}</div>
							) : null}
						</div>
					</div>
					<span className={styles.profileLink}>프로필 상세</span>
				</div>
				<div className={styles.secondLayer}>
					<div className={styles.secondLayerLeft}>{displayIcon}</div>
					{!alreadyOffer && !actionDisabled && (
						<div
							className={styles.secondLayerRight}
							onClick={() => {
								// store에 선택된 프로 데이터 저장
								const payload = {
									offerInput: {
										...state.offerInput,
										selectedPro: pro,
										targetUserId: pro?.id,
									},
								}
								actions.updateStore(payload)
								navigate('/search?tab=partner')
							}}>
							제안하기
						</div>
					)}
				</div>
			</div>

			<ModalProProfile
				modalVisible={isProfileModalOpen}
				onClose={() => setIsProfileModalOpen(false)}
				user={pro}
			/>
		</>
	)
}

export default ProDisplay
